import templateConstants from '../../template/constants';
import actionTypes from '../constants/action-types';

const mainLocale = (state = templateConstants.DEFAULT_TEMPLATE_LOCALE, action) => {
  switch (action.type) {
    case actionTypes.SAVE_MAIN_LOCALE:
    case actionTypes.SET_MAIN_LOCALE:
      return action.payload.locale;
    default:
      return state;
  }
};

export default mainLocale;
